export const durationHourCookieCheckoutWeb = 8;

export enum CheckoutWebSessionKey {
  Id = 'rappi.id',
  Type = 'rappi.type',
}

export enum CheckoutWebSessionType {
  Authenticated = '1',
  Guest = '0',
}

